import React from 'react'
import {Select} from 'antd'

const BSelect = ({children, onChange, defaultValue, width}) => (
  <div>
    <Select className='BSelect' defaultValue={defaultValue} style={{width: width ?? 300}} onChange={onChange}>
      {children}
    </Select>
  </div>
)

export default BSelect
